import React from 'react';
import classNames from 'classnames';

import { useLocale } from '../../hooks/use-locale';
import { pxToRem } from '../../utils/functions';
import ScreenReaderMessage from '../accessibility/screen-reader-message';

import { SpinnerProps } from './spinner-types';

const Spinner = ({ size = 'medium', type, inWrapper }: SpinnerProps) => {
  const { Message } = useLocale();

  const sizeRem = pxToRem(size === 'small' ? 24 : size === 'medium' ? 48 : 64);

  const info = (
    <div className="spinner__info">
      <h2 className="has-white-base-color">{`${Message.LOADING_CONTENT}...`}</h2>
      <h4 className="has-white-base-color nomargin">
        {Message.PLEASE_WAIT.toUpperCase()}
      </h4>
    </div>
  );

  const spinner = (
    <div
      className={classNames('spinner__loader', {
        'has-white-base-color': type === 'light',
        'has-black-base-color': type === 'dark',
      })}
      role="status"
      style={{
        height: sizeRem,
        width: sizeRem,
      }}
    >
      <ScreenReaderMessage message={`${Message.LOADING_CONTENT}...`} />
    </div>
  );

  return inWrapper ? (
    <div className="spinner__wrapper">{spinner}</div>
  ) : (
    <>
      {info}
      {spinner}
    </>
  );
};

export default Spinner;
